<template>
  <div id="population_wastewater_ship">
    <div v-if="receivedData">
      <SelectGraphic 
        :receivedData="receivedData"
        id="population_wastewater_ship"
      />
    </div>
  </div>
</template>
<script>

import CMS from '@/model/cms'
import Service from '@/service/service.js'
import { mapGetters } from 'vuex'

export default {
  name: 'PopulationWastewater',
  components: {
    SelectGraphic: () => import('@/components/graph/SelectGraphic.vue'),
  },

  data () {
    return {
      receivedData: null,
      blockId: 'population_wastewater',
      cloneElementId: 'population_wastewater_ship'
    }
  },

  computed: {
    ...mapGetters({
      userToken: 'getUserToken'
    }),
  },
    
  mounted() {
    this.fetchData()
  },

  methods: {
    fetchData () {
      this.getGraphData()
      Service.elementClone(this.blockId, this.cloneElementId)
    },

    getGraphData() {
      CMS.getGraph(this.userToken, '88,89,90,91,92,93,94,95').then((response) => {
        this.receivedData = response.data
      })
    }
  }
}
</script>